import { render, staticRenderFns } from "./SplitPack.vue?vue&type=template&id=9c0e5940&scoped=true&"
import script from "./SplitPack.vue?vue&type=script&lang=js&"
export * from "./SplitPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0e5940",
  null
  
)

export default component.exports